import { Link } from 'react-router-dom';

export default function SeoServices() {
  const services = [
    {
      icon: 'ri-map-pin-line',
      title: 'Piano Removals London',
      description: 'Complete guide to specialist piano removal services across all 32 London boroughs',
      link: '/piano-removals-london'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Grand Piano Removal',
      description: 'Expert grand piano moving — baby grand, boudoir and concert grand specialists',
      link: '/grand-piano-removal-london'
    },
    {
      icon: 'ri-piano-line',
      title: 'Upright Piano Removal',
      description: 'Professional upright piano removal service with specialist equipment and insurance',
      link: '/upright-piano-removal-london'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Piano Removal Costs',
      description: '2026 price guide — upright from £149, grand from £320. Complete cost breakdown',
      link: '/piano-removal-cost-london'
    }
  ];

  return (
    <section className="py-16 px-6 bg-[#1a1916]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="bg-[#0e0d0b] p-6 rounded-lg border border-[#c9a84c]/20 hover:border-[#c9a84c] transition-all hover:shadow-lg hover:shadow-[#c9a84c]/10 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg mb-4 group-hover:bg-[#c9a84c]/20 transition-colors">
                <i className={`${service.icon} text-2xl text-[#c9a84c]`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-[#f5f5f0] group-hover:text-[#c9a84c] transition-colors">
                {service.title}
              </h3>
              <p className="text-[#d4d4ce] text-sm leading-relaxed">
                {service.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}